<template>
  <a-config-provider :locale="locale">
    <router-view />
  </a-config-provider>
</template>

<script setup>
import {ref} from "vue";
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';

const locale = ref(zhCN)
dayjs.locale('zh-cn');  // 修改日期组件为中文
</script>

<style lang="scss">
@import '@/assets/styles/common.scss';
</style>